import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiService } from '../../services/api-service';

export const erInnlogget = createAsyncThunk<boolean>(
  'bruker/erInnlogget',
  apiService.isLoggedIn
);

export const hentTilganger = createAsyncThunk(
  'bruker/hentTilganger',
  apiService.getCompanyAccesses
);

export const requestToken = createAsyncThunk(
  'bruker/hentToken',
  apiService.getToken
);
